import { render } from "./MiniProgramSetting.vue?vue&type=template&id=5a077d7c&scoped=true"
import script from "./MiniProgramSetting.vue?vue&type=script&lang=js"
export * from "./MiniProgramSetting.vue?vue&type=script&lang=js"

import "./MiniProgramSetting.vue?vue&type=style&index=0&id=5a077d7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a077d7c"],['__file',"src/views/h5/common/sys/miniProgram/setting/MiniProgramSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a077d7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a077d7c', __exports__)) {
    api.reload('5a077d7c', __exports__)
  }
  
  module.hot.accept("./MiniProgramSetting.vue?vue&type=template&id=5a077d7c&scoped=true", () => {
    api.rerender('5a077d7c', render)
  })

}


export default __exports__